import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducer";
import themeSettingSlice from "./themeSettingSlice";
import authSlice from "./auth.slice";
import userSlice from "./user.slice";
import companySlice from "./company.slice";
import storeSlice from "./store.slice";
import taxSlice from "./tax.slice";
import bankAccountSlice from "./bankAccount.slice";
import vatSituationSlice from "./vatSituation.slice";
import companyTypesSlice from "./companyType.slice";
import paymentMethodsSlice from "./paymentMethod.slice";
import supplierSlice from "./supplier.slice";
import productSlice from "./product.slice";
import unitSlice from "./unit.slice";
import contractSlice from "./contract.slice";
import modelSlice from "./model.slice";
import customerSlice from "./customer.slice";
import groupSlice from "./group.slice";
import orderSlice from "./order.slice";
import orderStatusSlice from "./orderStatus.slice";
import saleSlice from "./sale.slice";
import posSlice from "./pos.slice";
import invoiceSlice from "./invoice.slice";
import quoteSlice from "./quote.slice";
import manufacturingOrderSlice from "./manufacturingOrder.slice";
import purchaseSlice from "./purchase.slice";
import userPointSlice from "./userpoint.slice";
import inventorySlice from "./inventory.slice";
import stockSlice from "./stock.slice";
import transferSlice from "./transfer.slice";
import paymentSlice from "./payment.slice";
import dashboardReducer from "./dashboard.slice";
import productFiltersSlice from "./productsFilter.slice";
import saleFiltersSlice from "./salesFilter.slice";
import customerOrderFiltersSlice from "./customerOrdersFilters.slice";
import shopOrdersFiltersReducer from "./shopOrdersFilters.slice";
import incomePaymentsFiltersReducer from "./incomePaymentsFilters.slice";

import supplierOderSlice from "./supplierOrder.slice";
import zoneReducer from "./zone.slice.js";
import roomReducer from "./room.slice";
import restaurantTableReducer from "./restaurantTable.slice.js";
import mealSubscriptionReducer from "./mealSubscription.slice";
import beneficiarySubscriptionReducer from "./beneficiarySubscription.slice";
import menuReducer from "./menu.slice";
import menuPlanReducer from "./menuPlan.slice";

import posRechargeSlice from "./posRecharge.slice";
import mealReservationReducer from "./mealReservation.slice";

import licenseReducer from "./license.slice";
import companySubscriptionReducer from "./companySubscription.slice";

import pathologyReducer from "./pathology.slice";
import allergenReducer from "./allergen.slice.js"
const store = configureStore({
  reducer: {
    rootReducer: rootReducer,
    themeSetting: themeSettingSlice,
    auth: authSlice,
    user: userSlice,
    company: companySlice,
    store: storeSlice,
    tax: taxSlice,
    bankAccounts: bankAccountSlice,
    vatSituation: vatSituationSlice,
    companyType: companyTypesSlice,
    paymentMethod: paymentMethodsSlice,
    supplier: supplierSlice,
    product: productSlice,
    unit: unitSlice,
    contract: contractSlice,
    model: modelSlice,
    customer: customerSlice,
    group: groupSlice,
    order: orderSlice,
    orderStatus: orderStatusSlice,
    sale: saleSlice,
    pos: posSlice,
    manufacturingOrder: manufacturingOrderSlice,
    invoice: invoiceSlice,
    quote: quoteSlice,
    purchase: purchaseSlice,
    userPoint: userPointSlice,
    inventories: inventorySlice,
    stocks: stockSlice,
    transfer: transferSlice,
    dashboardSlice: dashboardReducer,
    productsFilter: productFiltersSlice,
    salesFilter: saleFiltersSlice,
    customerOrdersFilters: customerOrderFiltersSlice,
    shopOrdersFilters: shopOrdersFiltersReducer,
    payment: paymentSlice,
    incomePaymentsFilters: incomePaymentsFiltersReducer,
    supplierOrder: supplierOderSlice,
    zone: zoneReducer,
    room: roomReducer,
    restaurantTable: restaurantTableReducer,
    posRecharge: posRechargeSlice,
    mealSubscription: mealSubscriptionReducer,
    beneficiarySubscription: beneficiarySubscriptionReducer,
    menu: menuReducer,
    menuPlan: menuPlanReducer,
    mealReservation: mealReservationReducer,
    pathology: pathologyReducer,
    allergen:allergenReducer,
    license: licenseReducer,
    companySubscription: companySubscriptionReducer,
  },
});

export default store;
